// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--RNdSK","icon":"_02712f2b3b--icon--dF9uI","info":"_02712f2b3b--info--B_DNZ","message":"_02712f2b3b--message--atDlj"};